import { IShortNews } from "@interfaces/user/shortNews";
import { createContext, useContext } from "react";

const NewsContext = createContext<IShortNews>(undefined as any);
export const NewsProvider = NewsContext.Provider;

export function useNewsContext(): IShortNews | undefined {
    return useContext(NewsContext);
}